import styled from 'styled-components';

export const SubHeading = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: ${({ theme }) => theme.spacing.sm};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 12px;
  }
`;
